import LabelField from '@app/components/atoms/LabelField/LabelField'
import Section from '@app/components/atoms/Section/Section'
import { yupResolver } from '@hookform/resolvers/yup'
import { Inertia } from '@inertiajs/inertia'
import { InertiaLink } from '@inertiajs/inertia-react'
import { CheckBoxOutlineBlank, CheckBox } from '@mui/icons-material'
import { Button, Grid, MenuItem, TextField, Autocomplete, Checkbox } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useState } from 'react'
import { Controller } from 'react-hook-form'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import EmployeeEditSchema from '../EmployeeCreate/EmployeeSchema'

const ButtonCustom = styled(Button)({
  marginTop: 20,
  marginRight: 20,
})

export default function EmployeeEdit({ employee, pos, status }) {
  const { t } = useTranslation()
  const [disableBtn, setDisableBtn] = useState(false)

  const checkedIcon = <CheckBox fontSize="small" />
  const icon = <CheckBoxOutlineBlank fontSize="small" />

  const initialValues = {
    ...employee,
  }

  const onSubmit = (data) => {
    setDisableBtn(true)
    Inertia.put(route('merchant.employees.update', { id: data.id }), data, {
      onError: (errors) => {
        setError('phone', { message: t(errors.phone) })
      },
    })
  }

  Inertia.on('finish', () => setDisableBtn(false))

  const {
    register,
    handleSubmit,
    control,
    setValue,
    setError,
    getValues,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    defaultValues: initialValues,
    resolver: yupResolver(EmployeeEditSchema),
  })

  return (
    <Grid container component="form" spacing={2} onSubmit={handleSubmit(onSubmit)}>
      <Grid item xs={12}>
        <Section title={t('EMPLOYEE.BASIC_INFORMATION')}>
          <Grid container>
            <Grid item lg={7} md={12} sm={12} xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <LabelField required title={t('EMPLOYEE.NAME')}>
                    <TextField
                      fullWidth
                      name="name"
                      {...register('name')}
                      error={errors.name ? true : false}
                      helperText={errors.name?.message}
                      size="small"
                      type="text"
                      variant="outlined"
                    />
                  </LabelField>
                </Grid>

                <Grid item xs={12}>
                  <LabelField required title={t('EMPLOYEE.PHONE')}>
                    <TextField
                      disabled
                      fullWidth
                      {...register('phone')}
                      error={errors.phone ? true : false}
                      helperText={errors.phone?.message}
                      name="phone"
                      size="small"
                      type="text"
                      variant="outlined"
                    />
                  </LabelField>
                </Grid>

                <Grid item xs={12}>
                  <LabelField required title={t('EMPLOYEE.STATUS')}>
                    <Controller
                      control={control}
                      name="status"
                      render={() => (
                        <TextField
                          fullWidth
                          select
                          name="status"
                          size="small"
                          value={getValues('status')}
                          variant="outlined"
                          {...register('status')}
                          error={errors.status ? true : false}
                          helperText={errors.status?.message}
                        >
                          {status.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {t(option.name)}
                            </MenuItem>
                          ))}
                        </TextField>
                      )}
                    />
                  </LabelField>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Section>
      </Grid>

      <Grid item xs={12}>
        <Section title={t('EMPLOYEE.POS')}>
          <Grid container>
            <Grid item lg={7} md={12} sm={12} xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <LabelField required title={t('MERCHANT.POS')}>
                    <Controller
                      control={control}
                      name="pos"
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          disableCloseOnSelect
                          multiple
                          getOptionLabel={(option) => option.address}
                          id="checkboxes-pos"
                          isOptionEqualToValue={(option, value) => option.id === value.id}
                          options={pos}
                          {...register('pos')}
                          renderInput={(params) => (
                            <TextField {...params} error={errors.pos ? true : false} helperText={errors.pos?.message} />
                          )}
                          renderOption={(props, option, { selected }) => (
                            <li {...props}>
                              <Checkbox
                                checked={selected}
                                checkedIcon={checkedIcon}
                                icon={icon}
                                style={{ marginRight: 8 }}
                              />
                              {option.address}
                            </li>
                          )}
                          onChange={(e, value) => setValue('pos', value)}
                        />
                      )}
                    />
                  </LabelField>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Section>
      </Grid>

      <Grid item xs={12}>
        <ButtonCustom disabled={disableBtn} type="submit" variant="contained">
          {t('BUTTON.SAVE')}
        </ButtonCustom>
        <ButtonCustom
          color="inherit"
          component={InertiaLink}
          href={route('merchant.employees.index')}
          variant="contained"
        >
          {t('BUTTON.CANCEL')}
        </ButtonCustom>
      </Grid>
    </Grid>
  )
}
